export const FREE_REPORT = "FREE";
export const COMPLETE_REPORT = "COMPLETE";
export const PROFESSIONAL_REPORT = "PROFESSIONAL";
export const INTELLIGENSE_REPORT = "INTELLIGENSE";
export const LEADERSHIP_REPORT = "LEADERSHIP";
export const PERSONALITY_REPORT = "PERSONALITY";
